var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1655 15.5L0.5 13.8345L6.33449 8.00006L0.5 2.16556L2.1655 0.5L8 6.3345L13.8345 0.5L15.5 2.1655C13.1765 4.50947 11.989 5.65604 9.6655 8L15.5 13.8345L13.8345 15.5L8 9.6655L2.1655 15.5Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1655 15.5L0.5 13.8345L6.33449 8.00006L0.5 2.16556L2.1655 0.5L8 6.3345L13.8345 0.5L15.5 2.1655C13.1765 4.50947 11.989 5.65604 9.6655 8L15.5 13.8345L13.8345 15.5L8 9.6655L2.1655 15.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.c13f7a1126460efd8b5d554658e59b20.svg";
export { ForwardRef as ReactComponent };